// CREATE JOB SEARCH ALERT ****************************************************************************
// pathname: /v1/job-search-alert
// ****************************************************************************************************
import { useSwrMutationApi } from 'src/hooks/useSwrApi';

/**
 * @description SWR mutation: POST create job search alert.
 * @param searchId - string. Job search id.
 * @param locale - string. The locale to use for the request. Default: 'ro'.
 * @param successCallback - function. The callback to call on success.
 * @param successToastText - string. The text to show in the success toast.
 */
export const useSwrCreateJobSearchAlert = (searchId: string, locale = 'ro', successCallback?: () => void, successToastText?: string) => {
  // SWR mutation
  // ********************************************
  const {
    data, error, isMutating, reset, trigger,
  } = useSwrMutationApi<object, undefined>({
    url: `/v1/job-search-alert/create/${searchId}`,
    locale,
    fetcherConfig: {
      method: 'POST',
    },
    apiOptions: {
      onSuccess: () => {
        // Callback
        if (successCallback) successCallback();
      },
    },
    toastsOptions: {
      showSuccessToast: true,
      successToastText,
      showErrorToast: true,
    },
  });


  // Return data
  // ********************************************
  return {
    data,
    error,
    isMutating,
    reset,
    trigger,
  };
};
